<template>
  <!-- Layout inner -->
  <div class="layout-inner explore_entity_result pg_bookmark_list">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">

        <div class="hd_bar">
          <div class="hd_ic">
            <span class="ic-bookmark"></span>
          </div>
          <div class="hd_txt">
            <span class="title_txt">My Bookmarks</span>
          </div>
        </div>

        <!-- Page content -->
        <div class="container-fluid flex-grow-1 pg_content_container" style="padding: 0px;">
          <template v-if="isLoading">
            <div class="row mt-3">
              <div class="w-100" style="padding: 150px 0;">
                <spinner size="large"></spinner>
              </div>
            </div>
          </template>
          <template v-else>
            <div>
              <div class="card" style="background: #f5f5f5;">
                <div class="card-body" style="padding: 0 !important;">
                  <div class="row">
                    <div class="container">
                      <div class="col-sm-3 col-xl-3">
                        <div class="pt-1 pb-1">
                          <input type="text" class="search-input" placeholder="search by name" v-on:keyup.enter="searchBookmarks" v-model.trim="searchName"/>
                          <div class="clear-btn" v-if="this.searchName.length > 0"  @click="searchBookmarks">
                            <b-btn @click="searchName = ''">X</b-btn>
                          </div>
                          <span @click="searchBookmarks" class="search-icon">
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <template v-if="bookmarks && bookmarks.length > 0">
                <!--
                <div class="row mt-3">
                  <div class="col-7 text-center"><strong>Name</strong></div>
                  <div class="col-3 text-center"><strong>Type</strong></div>
                  <div class="col-2 text-center"><strong>Action</strong></div>
                </div>
              -->
                <div class="row bookmark_row" v-for="bookmark in bookmarks">

                  <div class="col-1 ic_container">
                    <span class="ic " :class="bookmarkIconClass(bookmark)"></span>
                  </div>

                  <div class="col-10 entity_name">
                    <a href="javascript://" @click="goToBookmark(bookmark)">
                      {{ bookmark.entityTitle }}
                      <span v-if="bookmark.type && bookmark.type === 'CAREER_INTEREST'">(Career Interest)</span> <span v-if="bookmark.type && bookmark.type === 'PROGRAM_INTEREST'">(Program Interest)</span>
                    </a>
                  </div>

                  <div class="col-1 action">
                    <span @click="showDeleteBookmarkConfirmBox(bookmark)">
                      <i class="icon-bin" aria-hidden="true"></i>
                    </span>
                  </div>

                </div>
              </template>
              <template v-else>
                <div class="container">
                  <div class="row">
                    <div class="no_result">No Results Found</div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div>
      <b-modal class="delete-folder-popup" ref="bookmarkModal" ok-disabled cancel-diasbled no-close-on-backdrop no-close-on-esc centered>
        <template v-slot:modal-title>
          Please Confirm!
        </template>
        <div class="d-block text-center">
            <span>{{ bookmarkDeleteMessage }}</span>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteBookmarkAndHideDeleteConfirmBox" class="btn-footer button-primary float-right mr-2"> yes </b-button>
          <b-button @click="hideDeleteConfirmBox" class="btn-footer button-primary float-right mr-2"> no </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Navbar from '../../misc/components/./Navbar'

export default {
  name: 'bookmarks',
  components: {
    Navbar
  },
  data () {
    return {
      isLoading: true,
      pageSize: 100,
      sizeOptions: [ 10, 50, 100 ],
      firstPage: true,
      lastPage: false,
      page: 0,
      bookmarks: [],
      totalPages: 0,
      totalElements: 0,
      isBookmarksLoaded: false,
      searchName: '',
      bookmarkDeleteMessage: '',
      bookmarkToBeDeleted: {}
    }
  },

  async mounted () {
    await this.loadBookmarkList()
  },
  methods: {
    ...mapActions([
      'loadBookmarks',
      'loadDeleteBookmark',
      'loadCareerUsingUuid',
      'loadProgramGuideUsingUuid'
    ]),
    loadBookmarkList () {
      this.loadBookmarks({page: this.page, count: this.pageSize, name: this.searchName}).then(result => {
        result = result && result.length > 0 ? result[0] : result
        this.bookmarks = result.content
        this.page = result.number
        this.firstPage = (result.first || result.firstPage) ? (result.first || result.firstPage) : false
        this.lastPage = (result.last || result.lastPage) ? (result.last || result.lastPage) : false
        this.totalPages = result.totalPages
        this.totalElements = result.totalElements
        this.isBookmarksLoaded = true
        this.isLoading = false
      })
      this.$forceUpdate()
    },
    showDeleteBookmarkConfirmBox (bookmark) {
      this.bookmarkToBeDeleted = bookmark
      this.$refs.bookmarkModal.show()
      if (bookmark.type && bookmark.type === 'CAREER_INTEREST') {
        this.bookmarkDeleteMessage = 'You had selected ' + bookmark.entityTitle + ' as your career of interest!  Deleting this bookmark will remove this from your interest list and change the recommendations you see.  Do you still want to delete it?'
      } else if (bookmark.type && bookmark.type === 'PROGRAM_INTEREST') {
        this.bookmarkDeleteMessage = 'You had selected ' + bookmark.entityTitle + ' as your program of interest!  Deleting this bookmark will remove this from your interest list and change the recommendations you see.  Do you still want to delete it?'
      } else {
        this.bookmarkDeleteMessage = 'Are you sure you would like to delete this bookmark?'
      }
    },
    deleteBookmarkAndHideDeleteConfirmBox () {
      this.$refs.bookmarkModal.hide()
      this.deleteBookmarkClicked()
    },
    deleteBookmarkClicked () {
      if (this.bookmarkToBeDeleted && this.bookmarkToBeDeleted.uuid) {
        this.loadDeleteBookmark(this.bookmarkToBeDeleted.uuid).then(res => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully deleted \'' + this.bookmarkToBeDeleted.entityTitle + '\''
          })
          this.loadBookmarkList()
        })
      }
    },
    hideDeleteConfirmBox () {
      this.programGuideToBeDeleted = {}
      this.$refs.bookmarkModal.hide()
    },
    searchBookmarks () {
      this.page = 0
      this.loadBookmarkList()
    },
    goToBookmark (bookmark) {
      if (bookmark.entityType === 'career') {
        this.isLoading = true
        this.loadCareerUsingUuid(bookmark.entityUuid).then(career => {
          this.isLoading = false
          if (career && career.code) {
            return this.$router.push({name: 'careerHome', params: {code: career.code, isComingFromBookmark: true}})
          }
        })
      } else if (bookmark.entityType === 'programguide') {
        this.isLoading = true
        this.loadProgramGuideUsingUuid(bookmark.entityUuid).then(programGuide => {
          this.isLoading = false
          if (programGuide && programGuide.cipCode) {
            let routerParams = {
              cipCode: programGuide.cipCode,
              programGuideCode: programGuide.code,
              type: programGuide.type,
              isComingFromBookmark: true
            }
            return this.$router.push({name: 'programGuideMenu', params: routerParams})
          } /* else {
            return this.$notify({
              group: 'notify',
              type: 'warn',
              title: '',
              text: 'The selected Program Guide has no associated cip code. Unable to render page.'
            })
          } */
        })
      } else if (bookmark.entityType === 'job') {
        return this.$router.push({ name: 'jobHome', params: { uuid: bookmark.entityUuid } })
      } else if (bookmark.entityType === 'employer') {
        return this.$router.push({ name: 'employerDetails', params: { uuid: bookmark.entityUuid } })
      } else if (bookmark.entityType === 'stream') {
        console.log('page not found')
        // return this.$router.push({ name: 'streamTime', params: { uuid: bookmark.entityUuid } })
      } else if (bookmark.entityType === 'catalogs') {
        console.log('page not found')
        // return this.$router.push({ name: 'catalogDetail', params: { uuid: bookmark.entityUuid, loadDataFromServer: true } })
      }
    },
    getEntityTypeValue (entityType) {
      let getEntityType = entityType
      if (entityType === 'programguide') {
        return 'program'
      } else {
        return getEntityType
      }
    },
    bookmarkIconClass (bookmark) {
      if (bookmark.entityType === 'job') {
        return 'ic2_job-briefcase'
      }
      if (bookmark.entityType === 'employer') {
        return 'ic2_employer'
      }
      return 'ic-' + this.getEntityTypeValue(bookmark.entityType)
    },
    resetPage () {
      this.page = 0
      this.loadCareerList()
    },
    prev () {
      this.page = this.page - 1
      this.loadCareerList()
    },
    next () {
      this.page = this.page + 1
      this.loadCareerList()
    }
  }
}
</script>

<style scoped>
  .search-input {
    width: 60%;
    height: 30px;
    padding-left: 10px;
  }

  .search-icon {
    padding: 7px;
    margin-top: -3px;
  }

  .clear-btn {
    position: absolute;
    background: #fff;
    left: 290px;
    top: 2px;
  }

  .clear-btn .btn {
    border-radius: 50%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    padding: 0;
    position: absolute;
    right: 5px;
    top: 6px;
    background: #eee;
    font-size: 13px;
    color: #666869;
  }

  .btn-footer {
    font-size: 18px !important;
    padding: 1px 12px;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/BookmarkList.vue